import { useContext } from 'react';

import { BackgroundActivityRegistry } from '@services/backgroundActivityRegistry';
import { BackgroundActivityRegistryContext } from '@shared/BackgroundActivityContext';

export function useBackgroundActivityRegistry(): BackgroundActivityRegistry {
  const ctx = useContext(BackgroundActivityRegistryContext);
  if (!ctx) {
    throw new Error('useBackgroundActivityRegistry: missing <BackgroundActivityProvider>');
  }
  return ctx;
}
